import React from 'react';
import { Path, SVG } from 'web-common/src/shared/design-system/Utilities';

export const FollowOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <SVG height={24} width={24} viewBox={'0 0 24 24'} {...props}>
    <Path d='M19,22l-6.4-4.8c-0.4-0.3-0.9-0.3-1.2,0L5,22V3h14V22z M12,15c0.6,0,1.3,0.2,1.8,0.6L17,18V5H7v13l3.2-2.4C10.7,15.2,11.4,15,12,15z' />
  </SVG>
);

/**
 * @deprecated The shef-web design system is being retired. Use `components/Icon`
 *   from `web-common/src/shared/design-system` instead.
 * @see https://app.asana.com/0/0/1218340515027643
 */
export const Follow = (props: React.SVGProps<SVGSVGElement> & { outline?: boolean }) => {
  const { outline, ...svgProps } = props;
  return outline ? (
    <FollowOutline {...svgProps} />
  ) : (
    <SVG height={24} width={24} viewBox={'0 0 24 24'} {...svgProps}>
      <Path d='M5,4c0-0.6,0.4-1,1-1h12c0.6,0,1,0.4,1,1v16c0,0.8-0.9,1.3-1.6,0.8l-4.8-3.6c-0.4-0.3-0.8-0.3-1.2,0l-4.8,3.6C5.9,21.3,5,20.8,5,20V4z' />
    </SVG>
  );
};
